import { GraphQLFieldConfig, GraphQLList, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import {
  ApplicationQueryArgs,
  applicationQueryArgs
} from '../types/application-query-args'
import {
  SessionMetadataField,
  sessionMetadataFieldType
} from '../types/session-metadata-field'

function normalizeField({
  fieldId,
  displayLabel,
  agentLabel,
  count
}): SessionMetadataField {
  return {
    id: fieldId,
    displayLabel,
    agentLabel,
    count
  }
}

export const sessionMetadataAppFields: GraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs
> = {
  description: 'Get session metadata fields set by Application',
  type: new GraphQLNonNull(new GraphQLList(sessionMetadataFieldType)),
  args: applicationQueryArgs,
  async resolve(
    _source,
    { organizationID, applicationID },
    context
  ): Promise<SessionMetadataField[]> {
    const { fields = [] } = await context.connector.get(
      `${organizationID}/applications/${applicationID}/session-metadata/fields`
    )

    return fields.map(normalizeField)
  }
}
